<template>
  <div class="boxDetalhes" style="margin: 0px auto 0px; min-height: auto; max-width: 100%">
    <div class="box atual" v-loading="isLoading" :style="boxAtualStyle">
      <div class="cont" style="align-items: center;">
        <span style="font-size: 1rem">Vendas no dia</span>
        <strong style="font-size: 1.6rem">
          {{ sellsCurrentDay | toR$ }}
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
  import {getSellsCurrentDay} from "../../../services";
  import { makeErrorFilds } from "@/app/plugins/utils";

  export default {
    name: 'VendasNoDia',

    data() {
      return {
        isLoading: false,
        sellsCurrentDay: 0,
        boxAtualStyle: {
          background: "var(--primary-color)",
          color: "#fff",
        },
      }
    },

    methods: {
      async fetchSellsCurrentDay () {
        this.loadingPage = true;
        try {
          let response = await getSellsCurrentDay();
          this.sellsCurrentDay = response.data;
        } catch (e) {
          this.$message({
            showClose: true,
            message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
            type: "error",
          });
        } finally {
          this.loadingPage = false;
        }
      }
    },

    async beforeMount() {
      await this.fetchSellsCurrentDay();
    }
  }
</script>

<style scoped>

</style>